const formatCount = value => Number(value || 0).toLocaleString("es-CO");

export default function AdminPlanDistribution({ data }) {
  return (
    <section aria-labelledby="plan-distribution-title" className="rounded-xl border border-slate-200 dark:border-slate-700 p-4 md:p-5 space-y-4">
      <div>
        <h3 id="plan-distribution-title" className="font-bold text-slate-900 dark:text-slate-100">Personas por plan</h3>
        <p className="text-sm text-slate-500 dark:text-slate-400">Estado actual · No cambia con el período de actividad seleccionado.</p>
      </div>
      {!data ? <p role="status" className="text-sm text-slate-500">El desglose por plan aún no está disponible.</p> : <>
        <dl className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {[
            ["Total de personas", data.total_users],
            ["Gratis / sin plan activo", data.free_users],
            ["Con plan vigente hoy", data.subscribed_users],
          ].map(([label, value]) => <div key={label} className="rounded-xl bg-slate-50 dark:bg-slate-800 p-4">
            <dt className="text-xs font-semibold text-slate-500 dark:text-slate-400">{label}</dt>
            <dd className="mt-1 text-2xl font-bold text-cyan-700 dark:text-cyan-300">{formatCount(value)}</dd>
          </div>)}
        </dl>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <caption className="sr-only">Cantidad de personas con suscripción vigente en cada plan</caption>
            <thead><tr className="border-b border-slate-200 dark:border-slate-700 text-slate-500"><th scope="col" className="py-2 text-left font-medium">Plan</th><th scope="col" className="py-2 text-right font-medium">Personas</th></tr></thead>
            <tbody>{data.plans.map(plan => <tr key={plan.plan_id || "unidentified"} className="border-b last:border-0 border-slate-100 dark:border-slate-800">
              <th scope="row" className="py-3 text-left font-medium text-slate-800 dark:text-slate-200">{plan.name}{!plan.is_available && plan.plan_id && <span className="ml-2 text-xs font-normal text-slate-500">No disponible para nuevas compras</span>}</th>
              <td className="py-3 text-right font-bold tabular-nums">{formatCount(plan.count)}</td>
            </tr>)}</tbody>
          </table>
          {data.plans.length === 0 && <p className="py-3 text-sm text-slate-500">No hay planes configurados ni suscripciones vigentes.</p>}
        </div>
        {data.unverified_users > 0 && <p role="status" className="text-sm text-amber-700 dark:text-amber-300">Por verificar: {formatCount(data.unverified_users)} personas con suscripción sin una fecha de vencimiento válida. Están incluidas en el total.</p>}
        <p className="text-xs text-slate-500 dark:text-slate-400">Cada persona se cuenta una sola vez. Gratis incluye pruebas gratuitas y planes vencidos. Los planes vigentes incluyen activaciones manuales y cancelaciones con acceso aún vigente. Excluye administradores.</p>
      </>}
    </section>
  );
}
